import API from "@/http/http-client";
import ITextodealProvider from "@/interfaces/models/textodeal-provider.interface";

export const TextodealProviderService = {
  async fetchTextodealProvider(businessAccountId: number): Promise<ITextodealProvider> {
    const {data} = await API.get(`/deal/providers/${businessAccountId}`);
    return data;
  },
} 
